import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import { UserInfoModel } from "app/model/ua/user-info";
import { clearUserInfo } from "app/reducers/userSlice";
// AI 챗봇은 당분간 비활성화한다. 다시 켤 때는 이 파일의 "AI 챗봇 비활성화" 주석 블록을 되살린다.
// import { checkAiHealth, toggleChat } from "app/reducers/aiChatSlice";
import { Link, useNavigate } from "react-router-dom";
import AccountAlarm from "./AccountAlarm";

// const AiChatPanel = lazy(() => import("./aichat/AiChatPanel"));
// import AiChatHintBubble, {
//   hasUserOpenedAiChat,
//   markAiChatOpened,
//   RESPONSE_READY_MESSAGE,
// } from "./aichat/AiChatHintBubble";
import { AuthContextProps, useAuth } from "react-oidc-context";
import { startLogout } from "app/hooks/useSession";
// import { Bot } from "lucide-react";
import { LogOut, Settings } from "lucide-react";

export default function Account() {
  const auth: AuthContextProps = useAuth();
  const [isUserLogin, setIsUserLogin] = useState<any>(false);
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setIsUserLogin(!!userInfo?.userId);
  }, [userInfo?.userId]);

  /* AI 챗봇 비활성화 — 상태 확인(30초마다 health check)과 안내 말풍선
  const isChatOpen = useAppSelector(state => state.aiChat.isOpen);
  const serviceAvailable = useAppSelector(state => state.aiChat.serviceAvailable);
  const healthChecking = useAppSelector(state => state.aiChat.healthChecking);
  const responseReadyNotice = useAppSelector(state => state.aiChat.responseReadyNotice);
  const [hasOpenedChat, setHasOpenedChat] = useState(true);

  useEffect(() => {
    if (userInfo?.userId) {
      setHasOpenedChat(hasUserOpenedAiChat(userInfo.userId));
    } else {
      setHasOpenedChat(true);
    }
  }, [userInfo?.userId]);

  useEffect(() => {
    if (!isUserLogin || hasOpenedChat || isChatOpen || !userInfo?.userId) {
      return;
    }
    dispatch(checkAiHealth());
    const intervalId = globalThis.setInterval(() => {
      dispatch(checkAiHealth());
    }, 30_000);
    return () => globalThis.clearInterval(intervalId);
  }, [dispatch, hasOpenedChat, isChatOpen, isUserLogin, userInfo?.userId]);

  const showWelcomeHint = !hasOpenedChat && !isChatOpen && serviceAvailable && !healthChecking;
  const showResponseNotice = responseReadyNotice && !isChatOpen;
  const showHintBubble = showWelcomeHint || showResponseNotice;
  */

  const handleClickUser = (e: any) => {
    e.preventDefault();
    navigate('/mypage');
  }

  const handleLogout = async () => {
    localStorage.clear();
    dispatch(clearUserInfo());
    // 방식에 따라 절차가 다르다. BFF 는 게이트웨이 세션 하나만 끊으면 된다.
    void startLogout(auth);
  };

  /* AI 챗봇 비활성화 — 챗봇 버튼 클릭
  const handleClickChatbot = (e: React.MouseEvent) => {
    e.preventDefault();
    if (userInfo?.userId) {
      markAiChatOpened(userInfo.userId);
      setHasOpenedChat(true);
    }
    dispatch(toggleChat());
  };
  */

  return (
    <>
    <ul>
      {isUserLogin ? (
        <>
          {/* AI 챗봇 비활성화 — 챗봇 버튼
          <li className="chatbot ai-chat">
            <AiChatHintBubble
              visible={showHintBubble}
              message={showResponseNotice ? RESPONSE_READY_MESSAGE : undefined}
            />
            <Link to="" onClick={handleClickChatbot} title="AI 챗봇">
              <Bot className="util-icon" aria-hidden="true" />
              <span className="hid">AI 챗봇</span>
            </Link>
          </li>
          */}
          <li className="setting">
            <Link to="" onClick={handleClickUser} title="내 정보 화면으로 이동">
              <Settings className="icon util-icon" aria-hidden="true" />
              <span className="hid">내 정보</span>
            </Link>
          </li>
        </>
      ) : (
        <li className="login">
          <Link to="/" title="로그인 화면으로 이동"><span>로그인 해주세요</span></Link>
        </li>
      )}
      {isUserLogin && (<AccountAlarm/>)}
      {isUserLogin && (
        <li className="logout">
          <Link to="" onClick={handleLogout} title="로그아웃">
            <LogOut className="icon util-icon" aria-hidden="true" />
            <span className="hid">로그아웃</span>
          </Link>
        </li>
      )}
    </ul>
    {/* AI 챗봇 비활성화 — 챗봇 패널
    {isUserLogin && (
      <Suspense fallback={null}>
        <AiChatPanel />
      </Suspense>
    )}
    */}
    </>
  )
}
